import environment from "../../../environments/environment";
import { axiosInterceptor } from "../services/authInterceptor";
import { setLoginDetails } from "../../../store/features/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import * as constants from "../../../constants";
import { RootState } from "../../../store/store";
import { notifyUser } from "../Utils/notifyUser";
import { useTranslation } from "react-i18next";

const FISCAL_BASE_URL = environment.fiscalBaseURL;

interface PartTypes {
  page: number;
  size: number;
  isActive: string;
  clientId: number;
}

export function useParticipants() {
  const dispatch = useDispatch();
  const User = useSelector((state: RootState) => state.auth);
  const { t } = useTranslation();
  const translate = t as (key: string) => string;
  async function fetchParticipants() {
    let participantVO: PartTypes = {
      page: -1,
      size: -1,
      isActive: constants.IS_ACTIVE_YES,
      clientId: User.clientId,
    };
    try {
      const response = await axiosInterceptor.post(
        `${FISCAL_BASE_URL}participants/filter`,
        participantVO
      );
      if (response && response.status === constants.STATUS_CODES.SUCCESS) {
        dispatch(setLoginDetails({ participantArray: response?.data?.data }));
      }
    } catch (err: any) {
      if (err.status === constants.STATUS_CODES.NOT_FOUND) {
        dispatch(setLoginDetails({ participantArray: [] }));
      } else {
        notifyUser(
          err?.response?.data?.message ?? translate("apiRequestFailed"),
          "error",
          translate("participants")
        );
      }
    }
  }

  return { fetchParticipants };
}
